module.exports = __webpack_public_path__ + "static/media/ic_mail_outline1_24px.fba7e0ef.svg";